export default function footer(){ 
    function insertFooter() {
        var w_h = $(window).height()
        var scrollTop = $(window).scrollTop();
        var h = $('html').height();
        if ((scrollTop + w_h) / h >= 0.66) {
            var str = `
            <div class="footer_link_site flex b w-full items-center  justify-between">
                <div class="left_link_list flex flex-wrap justify-center ">
                    <a href="//union.yunshuren.com/" title="运能惠联" target="_blank" >
                        <img src="${public_domain}/images/tpu_img.png" class="" alt="运能惠联">
                    </a>
                    <a  href="//union.yunshuren.com/CEO_ONLINE/index.html" title="总裁在线" target="_blank" class="lg:px-8">
                        <img src="${public_domain}/images/ceo_img.png" class=" " alt="总裁在线">
                    </a>
                    <a href="/go.php?to=qichejingwei" title="汽车经纬" target="_blank" class="lg:px-8">
                        <img src="${public_domain}/images/qichejingwei.png" class=" " alt="汽车经纬">
                    </a>
                </div>
                <div class="right_qr_code flex justify-between  ">
                    <div class="right_qir_code_item flex items-center justify-center flex-col">
                        <img src="${public_domain}/images/two_dimension_code_01.jpg" alt="运输人移动官网"><span class="">运输人移动官网</span></div>
                    <div class="right_qir_code_item  flex items-center justify-center flex-col">
                        <img src="${public_domain}/images/two_dimension_code_02.jpg" alt="关注微信公众号">
                        <span class="">关注微信公众号</span>
                    </div>
                </div>
            </div>
            `
            
            $('.footer_sec_bg ').append($(str))
            $(window).off('scroll', insertFooter)
        }
    }
    $(window).on('scroll', insertFooter)
    

}